define.alias("shared/models/linkedin-post", "media/models/linkedin-post");